import React from 'react';
import { Box, Card, Skeleton } from '@mui/material';

const RightSideSkeleton = () => {
    return (
        <Box sx={{ marginBottom: '1rem' }}>
            <Card
                sx={{
                    padding: '1rem',
                    borderRadius: '12px',
                    border: '1px solid #f0f0f0',
                    backgroundColor: '#ffffff',
                    boxShadow: 'none'
                }}
            >
                <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }} gap={1}>
                    <Skeleton variant="circular" width={40} height={40} sx={{ backgroundColor: '#f0f0f0' }} />

                    <Box sx={{ flex: 1 }}>
                        <Skeleton
                            variant="text"
                            width="60%"
                            height={16}
                            sx={{
                                fontSize: '1rem',
                                backgroundColor: '#f0f0f0',
                                marginBottom: '4px'
                            }}
                        />

                        <Skeleton
                            variant="text"
                            width="40%"
                            height={14}
                            sx={{
                                fontSize: '0.875rem',
                                backgroundColor: '#f0f0f0'
                            }}
                        />
                    </Box>
                </Box>
                <Skeleton
                    variant="text"
                    width="100%"
                    height={14}
                    sx={{
                        fontSize: '1rem',
                        backgroundColor: '#f0f0f0',
                        marginBottom: '8px'
                    }}
                />
                <Skeleton
                    variant="text"
                    width="85%"
                    height={14}
                    sx={{
                        fontSize: '1rem',
                        backgroundColor: '#f0f0f0',
                        marginBottom: '8px'
                    }}
                />
                <Skeleton
                    variant="text"
                    width="70%"
                    height={14}
                    sx={{
                        fontSize: '1rem',
                        backgroundColor: '#f0f0f0'
                    }}
                />
            </Card>
        </Box>
    );
};

export default RightSideSkeleton;
